import { EditableCard } from "../../../components/editableCard.component";
import { ApiSchemaPatient } from "../../../models/api";
import { AppRouteUi } from "../../../config/appRoute";
import { useParams } from "react-router";

type Props = {
  data: ApiSchemaPatient | undefined;
  isValidating: boolean;
};

export const SpecialInstructionCard = (props: Props) => {
  const { patientId } = useParams<{ patientId: string }>();
  return (
    <EditableCard
      showLoader
      title="Special Instructions"
      isValidating={props.isValidating}
      link={`${AppRouteUi.Patient.Root()}/update/${patientId}`}
    >
      {props.data?.specialInstructions ? (
        <div>
          <p>{props.data.specialInstructions}</p>
        </div>
      ) : (
        <div className="py-4 text-muted d-flex justify-content-center">
          No Data Available
        </div>
      )}
    </EditableCard>
  );
};
